<mat-grid-list class="login-container" cols="3">
    <mat-grid-tile>
        <div class="container">
            <div id="form-container">
                <!-- LOGIN PAGE -->
                <form *ngIf="!isSignUp && !isVerificationPage" ngNoForm [formGroup]="loginForm" id="loginForm" (ngSubmit)="onSubmitLogIn()" #loginform>
                    <div class="Ez_logo">
                        <img src="../../assets/images/Ez_logo.png" class="Ez-logo">
                    </div>
                    <div class="form-group">
                        <input id="user_id" placeholder="Username" type="text" name="username" formControlName="userName"
                            matInput>
                        <span class="error-msg" *ngIf="submitted && !loginForm.controls.userName">Please enter valid email
                            id</span>
                    </div>
                    <div class="form-group">
                        <input id="user_password" placeholder="Password" type="password" formControlName="password"
                            name="password" matInput>
                        <span class="error-msg" *ngIf="submitted && !loginForm.controls.password">Please enter
                            password</span>
                    </div>
                    <div class="form-group error-block" *ngIf="submitted && hasError">
                        <span class="error-msg" *ngIf="submitted && hasError">{{errorMessage}}</span>
                    </div>
                    <div class="form-group loginForm">
                        <mat-checkbox class="remember-me" (change)="changeRememberMe()" [checked]="rememberMe">Remember me
                        </mat-checkbox>
                    </div>
                    <div class="form-group" id="login-button">
                        <button mat-flat-button color="warn" [class.spinner]="loading" (click)="save()"
                            [ngClass]="{ 'invalid-form' : !loginForm.valid, 'disable-form':isLoading} "
                            [disabled]="!loginForm.valid || isLoading" class="login_button_info"> LOGIN
                        </button>
                    </div>
                </form>
                <div *ngIf="!isSignUp && !isVerificationPage" id="signUp-button-cointainer">
                    <span style="color: grey; cursor: default;">Don't have an account?</span><button (click)="toggleSignUpPage()" class="simple-button" id="signUp-button">SignUp</button>
                </div>

                <!-- SIGNUP PAGE -->
                <form *ngIf="isSignUp && !isVerificationPage" ngNoForm [formGroup]="signUpForm" id="signUpForm" (ngSubmit)="sendOTP()">
                    <div class="Ez_logo">
                        <img src="../../assets/images/Ez_logo.png" class="Ez-logo">
                    </div>
                    <div class="form-group">
                        <input id="first_name" placeholder="Firstname" type="text" name="firstname" formControlName="FirstName"
                            matInput>
                    </div>
                    <div class="form-group">
                        <input id="last_name" placeholder="Lastname" type="text" name="lastname" formControlName="LastName"
                            matInput>
                    </div>
                    <div class="form-group">
                        <input id="email" placeholder="Email" type="text" name="email" formControlName="Email"
                            matInput>
                    </div>
                    <div class="form-group">
                        <input id="new_password" placeholder="Password" type="password" formControlName="Password"
                            name="new_password" matInput>
                    </div>
                    <div class="form-group">
                        <input id="client_id" placeholder="Client ID" type="number" formControlName="ClientID"
                            name="clientId" matInput>
                    </div>
                    <div class="form-group error-block" *ngIf="signUpFormSubmitted">
                        <span class="error-msg" *ngIf="signUpFormSubmitted">{{signUpErrorMessage}}</span>
                    </div>
                    <div class="form-group" id="login-button">
                        <button mat-flat-button color="warn" [class.spinner]="loading" (click)="save()"
                            [ngClass]="{ 'invalid-form' : !signUpForm.valid, 'disable-form':isLoading} "
                            [disabled]="!signUpForm.valid || isLoading" class="login_button_info"> NEXT
                        </button>
                    </div>
                </form>

                <!-- OTP VERIFICATION PAGE -->
                <form *ngIf="isVerificationPage && !isOTPVerified" ngNoForm [formGroup]="verifyOtpForm" id="OTPForm" (ngSubmit)="onVerifyOTP()">
                    <div class="Ez_logo">
                        <img src="../../assets/images/Ez_logo.png" class="Ez-logo">
                    </div>
                    <div class="form-group">
                        <h2 style="font-weight: 700;">OTP verification</h2>
                        <p style="color: grey;">Please enter the OTP(One-Time Password) sent to your registered email to complete your verification</p>
                    </div>
                    <div class="OTP-form-group">
                        <input type="text" class="otp-input-box" maxlength="1" (keyup)="move($event,null,digit1,digit2)" formControlName="digit1" #digit1 /> 
                        <input type="text" class="otp-input-box" maxlength="1" (keyup)="move($event,digit1,digit2,digit3)" formControlName="digit2" #digit2 /> 
                        <input type="text" class="otp-input-box" maxlength="1" (keyup)="move($event,digit2,digit3,digit4)" formControlName="digit3" #digit3 />
                        <input type="text" class="otp-input-box" maxlength="1" (keyup)="move($event,digit3,digit4,null)" formControlName="digit4" #digit4 />
                    </div>
                    <div class="form-group error-block" *ngIf="otpFormSubmitted">
                        <span class="error-msg" *ngIf="otpFormSubmitted">{{otpErrorMessage}}</span>
                    </div>
                    <div class="form-group" id="login-button">
                        <button mat-flat-button color="warn" (click)="save()"
                        [ngClass]="{'invalid-form':!verifyOtpForm.valid, 'disable-form':isLoading}"
                        [disabled]="!signUpForm.valid || isLoading"
                             class="login_button_info"> Verify OTP
                        </button>
                    </div>
                </form>
                <div *ngIf="isSignUp && !isOTPVerified" id="signUp-button-cointainer">
                    <span style="color: grey; cursor: default;">Have an account?</span><button (click)="toggleSignUpPage()" class="simple-button" id="signUp-button">Log In</button>
                </div>

                <!-- SUCCESSFULLY SIGNUP PAGE -->
                <form *ngIf="isOTPVerified" ngNoForm [formGroup]="loginForm" id="OTPForm" (ngSubmit)="redirectToLogin()" #signedUpform>
                    <div class="Ez_logo">
                        <img src="../../assets/images/Ez_logo.png" class="Ez-logo">
                    </div>
                    <div class="form-group">
                        <h2 style="font-weight: 700;">Account created Successfully!</h2>
                        <p style="color: grey">Please login with your credentials<button class="simple-button" id="signUp-button">Log In</button></p>
                    </div>
                </form>
                
            </div>
            
            <div class="available_text">
                <div class="available_position ">
                    <p class="text_info1 ">NOW AVAILABLE</p>
                    <p class="text_info2 ">Custom Green Complex Artwork</p>
                    <a class="learn_link " target="_blank " href="https://ezlocator.com/connected-club">Learn More </a>
                </div>
                <div class="bottom_position ">
                    <a class="dot_com " target="_blank " href="http://www.ezlocator.com ">EZLOCATOR.COM</a>
                    <p class="contact_details ">Contact the sales team at <br> <a class="block "
                            href="mailto:sales@ezlocator.com " target="_blank ">sales@ezlocator.com</a> or <a
                            class="block " href="tel:972-231-4040 ">972.231.4040</a></p>
                    <p class="copyright_content ">Copyright © ezLocator. All Rights Reserved.
                </div>
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>